import AddOpportunityModal from "@cc/modules/crm/AddOpportunityModal.vue";
import CreateCompanyModal from "@cc/modules/crm/company/CreateCompanyModal.vue";
import AddPeopleModal from "@cc/modules/crm/company/AddPeopleModal.vue";
import ProjectCreate from "@cc/clients/projects/ProjectCreate.vue";
import AddOpportunityBizDev from "@cc/modules/crm/opportunities/AddOpportunityBizDev.vue";

export default {
    methods: {
        addCompany(source='quick_menu') {
            this.$modal.show(
                CreateCompanyModal,
                {
                    source
                },
                {
                    height: "auto",
                    scrollable: true
                }
            );
        },
        addPeople(source='quick_menu') {
            this.$modal.show(
                AddPeopleModal,
                {
                    source
                },
                {
                    height: "auto",
                    scrollable: true
                }
            );
        },
        addProject(source='quick_menu') {
            this.$modal.show(
                ProjectCreate,
                {
                    source,
                    title: 'Create Project',
                },
                {
                    height: "auto",
                    scrollable: true
                }
            );
        },
        addOpportunity(source='quick_menu') {
            this.$modal.show(
                AddOpportunityModal,
                {
                    source
                },
                {
                    height: "auto",
                    scrollable: true
                }
            );
        },
        addOpportunityBizDev(source='quick_menu') {
            this.$modal.show(
                AddOpportunityBizDev,
                {
                    source
                },
                {
                    height: "auto",
                    scrollable: true
                }
            );
        },
    }
}